var generateRakutenUrl = function generateRakutenUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var url = new URL(trackingLink);
  url.searchParams.set('u1', userId);
  url.searchParams.set('murl', originalUrl);
  return url;
};

var generateImpactRadiusUrl = function generateImpactRadiusUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var url = new URL(trackingLink);
  url.searchParams.set('subId1', userId);
  url.searchParams.set('u', originalUrl);
  return url;
};

var generateCommissionJunctionUrl = function generateCommissionJunctionUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var trackingUrl = "".concat(trackingLink.replace('defaultvalue', "".concat(userId)), "/").concat(originalUrl);
  var url = new URL(trackingUrl);
  return url;
};

var generatePartnerizeUrl = function generatePartnerizeUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var trackingUrl = "".concat(trackingLink.replace('pubref:pubref', "pubref:".concat(userId)), "/destination:").concat(originalUrl);
  var url = new URL(trackingUrl);
  return url;
};

var generateShareASaleUrl = function generateShareASaleUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var url = new URL(trackingLink);
  url.searchParams.set('afftrack', userId);
  url.searchParams.set('urllink', originalUrl);
  return url;
};

var generatePepperjamUrl = function generatePepperjamUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var url = new URL(trackingLink);
  url.searchParams.set('sid', userId);
  url.searchParams.set('url', originalUrl);
  return url;
};

var generateAwinUrl = function generateAwinUrl(_a) {
  var trackingLink = _a.trackingLink,
      userId = _a.userId,
      originalUrl = _a.originalUrl;
  var url = new URL(trackingLink);
  url.searchParams.set('clickref', userId);
  url.searchParams.set('ued', originalUrl);
  return url;
};

var generateEbayUrl = function generateEbayUrl(_a) {
  var userId = _a.userId,
      originalUrl = _a.originalUrl;
  var url = new URL(originalUrl);
  url.searchParams.set('mkcid', '1');
  url.searchParams.set('mkrid', '711-53200-19255-0');
  url.searchParams.set('siteid', '0');
  url.searchParams.set('campid', '5338523788');
  url.searchParams.set('customid', userId);
  url.searchParams.set('toolid', '10001');
  url.searchParams.set('mkevt', '1');
  return url;
};

var generateTrackableLink = {
  commissionJunction: generateCommissionJunctionUrl,
  rakuten: generateRakutenUrl,
  impactRadius: generateImpactRadiusUrl,
  partnerize: generatePartnerizeUrl,
  shareASale: generateShareASaleUrl,
  pepperjam: generatePepperjamUrl,
  awin: generateAwinUrl,
  ebay: generateEbayUrl
};

var setChirpyestTrackingParams = function setChirpyestTrackingParams(url) {
  var chirpUrl = new URL(url); // chirpy=chirpyest is used by ext to identify the link as a chirpyest link
  // validated on page load by extension

  chirpUrl.searchParams.set('chirp', 'chirpyest');
  return chirpUrl.toString();
};

var removeQueryParamsfromProductUrlForDifferentNetworks = function removeQueryParamsfromProductUrlForDifferentNetworks(_a) {
  var originalUrl = _a.originalUrl,
      network = _a.network;
  var url = new URL(originalUrl);
  var newUrl = new URL(originalUrl);

  switch (network) {
    case 'rakuten':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['ranmid', 'raneaid', 'ransiteid', 'siteid'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'impactRadius':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['irclickid', 'clickid', 'clkid'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'commissionJunction':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['cjevent', 'cid', 'cjdata'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'awin':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['awc'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'ebay':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['irclickid', 'clickid'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'partnerize':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || key.includes('af_') || ['clickid', 'clickref'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'shareASale':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['dclid', 'sscid', 'ssaid'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    case 'pepperjam':
      url.searchParams.forEach(function (value, key) {
        if (key.includes('utm_') || ['clickid', 'click', 'subid2'].includes(key.toLowerCase())) {
          return newUrl.searchParams.delete(key);
        }
      });
      return newUrl.toString();

    default:
      return originalUrl;
  }
};

export var generateTrackingLink = function generateTrackingLink(params) {
  params.originalUrl = removeQueryParamsfromProductUrlForDifferentNetworks(params);
  params.originalUrl = setChirpyestTrackingParams(params.originalUrl);
  var trackingLink = generateTrackableLink[params.network](params);
  return decodeURIComponent(trackingLink.toString());
};